import { Environment } from '@pegasus/config';
const mapEnvironment = (environment) => {
    switch (environment) {
        case Environment.DEVELOPMENT:
        case Environment.DEVELOPMENT_PRODUCTION:
        case Environment.LOCAL_PRODUCTION:
        case Environment.TEST:
        case Environment.RELEASE:
        case Environment.STAGING:
        case Environment.REVIEW:
            return Environment.RELEASE;
        case Environment.UPCOMING:
            return Environment.UPCOMING;
        case Environment.PREVIEW:
        case Environment.PRODUCTION:
        default:
            return Environment.PRODUCTION;
    }
};
export const renderGTMLoader = ({ environment = Environment.PRODUCTION, salesChannel, trackingMode, }) => {
    const baseUrl = environment === Environment.PRODUCTION
        ? 'https://mosaic01.ztat.net/pgs'
        : 'https://pegasus-modules-test.s3.eu-central-1.amazonaws.com';
    const src = `${baseUrl}/modules/gtm-loader-2.0.0.js`;
    return `<script async id="gtm_loader" src="${src}" data-salesChannel="${salesChannel}" data-environment="${mapEnvironment(environment)}" data-tracking-mode="${trackingMode || '*'}"></script>`;
};
//# sourceMappingURL=index.js.map